<app-wizard-phase-header
  [phase]="phase()"
  [companyName]="tenderDetails().companyName"
  [projectName]="tenderDetails().projectName"
/>

<p-tabs appTabsUnsavedReveal [value]="activeTabIndex()" (valueChange)="onTabChange($event!)">
  <p-tablist>
    <p-tab [value]="0" [appTabStatus]="mailPreviewTabStatus()">
      <span>{{ 'provider.tenderWizard.mailPreview.tabTitle' | transloco }}</span>
    </p-tab>
    <p-tab [value]="1" [appTabStatus]="projectDescriptionTabStatus()">
      <span>{{ 'provider.tenderWizard.projectDescription.tabTitle' | transloco }}</span>
    </p-tab>
    @if (showDecisionTab()) {
      <p-tab [value]="2" [appTabStatus]="decisionTabStatus()">
        <span>{{ 'provider.tenderWizard.confirmation.tabTitle' | transloco }}</span>
      </p-tab>
    }
    @if (showQuestionnaireTab()) {
      <p-tab [value]="3" [appTabStatus]="questionnaireTabStatus()">
        <span>{{ 'provider.tenderWizard.subcriteriaAttributes.tabTitle' | transloco }}</span>
      </p-tab>
    }
  </p-tablist>

  <p-tabpanels class="mt-6">
    <p-card>
      <p-tabpanel [value]="0">
        <app-tender-invitation-mail [tenderDetails]="tenderDetails()" (nextTab)="goToNextTab()" />
      </p-tabpanel>
      <p-tabpanel [value]="1">
        @if (isRfi()) {
          <app-tender-project-description-rfi [tenderDetails]="tenderDetails()" />
        } @else {
          <app-tender-project-description [tenderDetails]="tenderDetails()" />
        }
        <div class="flex justify-end mt-6">
          <p-button label="{{ 'common.next' | transloco }}" (onClick)="goToNextTab()"></p-button>
        </div>
      </p-tabpanel>
      @if (showDecisionTab()) {
        <p-tabpanel [value]="2">
          <app-tender-confirmation
            [tenderDetails]="tenderDetails()"
            (accepted)="onTenderAccepted()"
            (rejected)="onTenderRejected()"
            [tenderPhase]="phase()"
          />
        </p-tabpanel>
      } @else if (showQuestionnaireTab()) {
        <p-tabpanel [value]="3">
          <app-generic-questionnaire
            [tenderId]="tenderId()"
            [phaseType]="phase()"
            [tenderDetails]="tenderDetails()"
            [showTenderProjectReferences]="true"
            (tabStatusChange)="onQuestionnaireStatusChange($event)"
            (sent)="onQuestionnaireSent()"
          />
        </p-tabpanel>
      }
    </p-card>
  </p-tabpanels>
</p-tabs>
